import Header from "@/types/app/header";

export default class CustomerAproovedHeader {
  public static header: Header[] = [
    {
      text: "Date of interest",
      align: "start",
      sortable: true,
      value: "date",
      class: "item-table-header-refused",
      width: ""
    },
    {
      text: "Name",
      align: "start",
      sortable: true,
      value: "fullName",
      class: "item-table-header-refused",
      width: ""
    },
    {
      text: "Email",
      align: "start",
      sortable: true,
      value: "email",
      class: "item-table-header-refused",
      width: ""
    },
    {
      text: "Country",
      align: "start",
      sortable: true,
      value: "country",
      class: "item-table-header-refused",
      width: ""
    },   
    {
      text: "Phone",
      align: "start",
      sortable: true,
      value: "phone",
      class: "item-table-header-refused",
      width: ""
    },
    {
      text: "Last login date",
      align: "start",
      sortable: true,
      value: "lastAccess",
      class: "item-table-header-refused",
      width: ""
    },
    {
      text: "", align: "right", value: "actions", sortable: false, class: null,
      width: "" }
  ];
}
